// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"patient","123":"case","391":"info","430":"doctor","594":"about","857":"report","962":"home","966":"login"}[chunkId] + "." + {"2":"8361d364","123":"23628497","391":"104fdbb4","430":"d199cd7c","594":"17c5bd1e","857":"16315864","962":"0e72c848","966":"d1e9dadf"}[chunkId] + ".js";
};